export default __webpack_public_path__ + "assets/5d252b7bef74a3f496a053b18881cdd4.svg";